import { isBlank } from 'utils/isBlank';
import * as Actions from './Actions';

const initialState = {
    customerTags: [],
    parentCustomer: {},
    billingAddressIndex: 0,
    expandedAddress: false,
    initialValues: {
        kind: 'homeowner',
        notifications_enabled: true,
        service_addresses: [{billing: true}]
    },
};

function createReducer(initialState, handlers) {
    return function reducer(state = initialState, action) {
        if (handlers.hasOwnProperty(action.type)) {
            return handlers[action.type](state, action)
        } else {
            return state
        }
    }
}

const AddOrEditCustomerReducer = createReducer(initialState, {
    [Actions.UPDATE_PARENT_CUSTOMER](state, action) {
        return Object.assign({}, state, {
            parentCustomer: action.customer
        })
    },
    [Actions.ADD_CUSTOMER_TAGS](state, action) {
        let currentTagNames = state.customerTags.map(tag => tag.name.toLowerCase());

        if (isBlank(action.tag.name) || currentTagNames.includes(action.tag.name.toLowerCase())) {
            return state;
        }
        return Object.assign({}, state, {
            customerTags: [...new Set([...state.customerTags, action.tag])]
        })
    },
    [Actions.DELETE_CUSTOMER_TAGS](state, action) {
        let tags = [...state.customerTags];

        state.customerTags.forEach((currentTag, index) => {
            if (currentTag.id === action.tag.id && currentTag.name === action.tag.name) {
                tags.splice(index, 1);
                return true;
            }
        });

        return Object.assign({}, state, {
            customerTags: tags
        });
    },
    [Actions.CLEAR_CUSTOMER_INITIAL_FIELDS](state, action) {
        return initialState;
    },
    [Actions.UPDATE_BILLING_ADDRESS_INDEX](state, action) {
        return Object.assign({} , state, {
            billingAddressIndex: action.index
        });
    },
    [Actions.UPDATE_EXPANDED_ADDRESS](state, action) {
        return Object.assign({} , state, {
            expandedAddress: action.key
        });
    }
});

export default AddOrEditCustomerReducer;
